const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	timestamp: null,
	datetime: null,
	searchCondionButtonBalloon: true,
	scrollpos: 0,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'SEARCH_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.timestamp = action.payload.timestamp;
		newState.datetime = new Date();
		return newState;
	}
	else if (action.type === 'SEARCH_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let index = newState.list.findIndex((v) => v.userdata_id_code === action.payload.pic);
			if (index >= 0) {
				newState.list.splice( index, 1 );
			}
		}
		return newState;
	}
	else if (action.type === 'SEARCH_ITEM_FOOTPRINT_MY_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.userdata_id_code === action.payload.pic);
		if (index >= 0) {
			newState.list[index]['footprint_my'] = action.payload.value;
		}
		return newState;
	}
	else if (action.type === 'SEARCH_ITEM_MEMO_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.userdata_id_code === action.payload.pic);
		if (index >= 0) {
			newState.list[index]['memo'] = action.payload.text;
		}
		return newState;
	}
	else if (action.type === 'SEARCH_SCROLLPOS_SET') {
		let newState = Object.assign({}, state);
		newState.scrollpos = action.payload.scrollpos;
		return newState;
	}
	else if (action.type === 'SEARCH_CONDITION_BUTTON_BALLOON_SET') {
		let newState = Object.assign({}, state);
		newState.searchCondionButtonBalloon = action.payload.bool;
		return newState;
	}
	else {
		return state;
	}
}
